import styles from "./Title.module.css";

const Title = ({ textTitle }) => {
  return <h1 className={styles.containerText}>{textTitle}</h1>;
};

export default Title;
